import React from "react";

// Hyper-realistic ad placeholders — AdSense slots and locally-sold sponsor ads.
export function AdSlot({ ad, className = "" }) {
  if (!ad) return null;
  const isAdsense = ad.adsense;
  return (
    <div
      data-testid={`ad-slot-${ad.slot}`}
      className={`relative overflow-hidden border ${
        isAdsense ? "border-dashed border-slate-300 bg-[var(--ad-bg)]" : "border-amber-200 bg-amber-50"
      } ${className}`}
    >
      <div className="flex items-center justify-between px-3 pt-2">
        <span className="eyebrow text-[10px] text-slate-500">{ad.label}</span>
        <span className="eyebrow text-[10px] text-slate-400">{ad.format}</span>
      </div>
      <div className="px-4 py-5 text-center">
        {ad.image && (
          <div className="img-zoom mb-3 overflow-hidden rounded">
            <img src={ad.image} alt={ad.sponsor} className="h-28 w-full object-cover" />
          </div>
        )}
        <p className="font-display text-lg font-bold text-[var(--navy)]">{ad.headline}</p>
        <p className="font-serif-body mt-1 text-sm text-slate-600">{ad.subtext}</p>
        <p className="eyebrow mt-3 text-[10px] text-slate-500">
          {isAdsense ? "via Google AdSense" : `Sponsored by ${ad.sponsor}`}
        </p>
      </div>
    </div>
  );
}

export function LeaderboardAd({ ad }) {
  if (!ad) return null;
  return (
    <div
      data-testid="ad-leaderboard"
      className="relative flex items-center justify-center gap-4 border-y border-dashed border-slate-300 bg-[var(--ad-bg)] px-4 py-3"
    >
      <span className="eyebrow absolute left-3 top-1 text-[9px] text-slate-400">{ad.label}</span>
      <span className="eyebrow absolute right-3 top-1 text-[9px] text-slate-400">{ad.format}</span>
      <div className="text-center">
        <p className="font-display text-base font-bold text-[var(--navy)] sm:text-lg">{ad.headline}</p>
        <p className="font-serif-body text-xs text-slate-600 sm:text-sm">{ad.subtext}</p>
      </div>
    </div>
  );
}

export function NativeAd({ ad }) {
  if (!ad) return null;
  return (
    <div
      data-testid="ad-native"
      className="card-hover flex gap-4 rounded-lg border-l-4 border-amber-400 bg-amber-50/70 p-4"
    >
      {ad.image && (
        <div className="img-zoom hidden h-24 w-32 shrink-0 overflow-hidden rounded sm:block">
          <img src={ad.image} alt={ad.sponsor} className="h-full w-full object-cover" />
        </div>
      )}
      <div>
        <span className="eyebrow text-[10px] text-amber-700">{ad.label}</span>
        <p className="font-display mt-1 text-base font-bold leading-snug text-[var(--navy)]">{ad.headline}</p>
        <p className="font-serif-body mt-1 text-sm text-slate-600">{ad.subtext}</p>
        <p className="eyebrow mt-2 text-[10px] text-amber-700">{ad.sponsor}</p>
      </div>
    </div>
  );
}
